export default __webpack_public_path__ + "static/media/microsoft-logo-icon.5fe3f3dd.svg";